import { render, staticRenderFns } from "./OrderExpressList.vue?vue&type=template&id=a48cfeba&scoped=true&"
import script from "./OrderExpressList.vue?vue&type=script&lang=js&"
export * from "./OrderExpressList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48cfeba",
  null
  
)

export default component.exports